<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { getRowLabel } from 'dashboard/constants/gch';
import Label from 'dashboard/components-next/label/Label.vue';

const props = defineProps({
  subject: { type: String, default: '' },
  labels: { type: Array, default: () => [] },
  messageCount: { type: Number, default: 0 },
});

const accountLabels = useMapGetter('labels/getLabels');

const label = computed(() => {
  const title = getRowLabel(props.labels, { isEmail: true });
  return accountLabels.value.find(item => item.title === title);
});
</script>

<template>
  <div
    class="flex flex-col flex-shrink-0 gap-1.5 px-6 pt-4 pb-3 border-b ltr:pr-16 rtl:pl-16 bg-n-surface-1 border-n-weak"
  >
    <h2 class="text-lg font-medium text-n-slate-12 text-pretty">
      {{ subject || $t('CONVERSATION.EMAIL_VIEW.NO_SUBJECT') }}
    </h2>
    <div class="flex items-center gap-2 text-sm text-n-slate-11">
      <Label v-if="label" :label="label" compact />
      <span>
        {{ $t('CONVERSATION.EMAIL_VIEW.MESSAGE_COUNT', messageCount) }}
      </span>
    </div>
  </div>
</template>
